import LabServiceModel from "@/models/LabServiceModel";
import AnalyteResultModel from "./AnalyteResultModel";
import AnalyteResultStatusModel from "./AnalyteResultStatusModel";

export default class AnalyteResultStatusLogModel extends LabServiceModel {
  modelName() {
    return 'analyte-result-status-log';
  }
  defaults() {
    return {
      id: null,
      analyte_result_id: null,
      analyte_result: null,
      analyte_result_status_id: null,
      analyte_result_status: null,
      start_date: null,
      end_date: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      analyte_result_id: (val) => (this.nullStringMutator(val)),
      analyte_result_status_id: (val) => (this.nullStringMutator(val)),
      start_date: (val) => (this.nullStringMutator(val)),
      end_date: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }
  validation() {
    return {}
  }
  getAnalyteResult() {
    return this.getRelatedModel(AnalyteResultModel, 'analyte_result');
  }
  getAnalyteResultStatus() {
    return this.getRelatedModel(AnalyteResultStatusModel, 'analyte_result_status');
  }
  getStatus() {
    return this.getAnalyteResultStatus();
  }
}
